import React from "react";
import {
  IAvailableGeometryOption,
  IAvailableOption,
  optionObjectOptionT,
} from "../../../../../../../redux/reducers/ui/uiTypes";
import { ObjectOption } from "../ObjectOption/ObjectOption";
import { ObjectOptionGroup } from "../ObjectOptionGroup/ObjectOptionGroup";

interface PropsI {
  productId: string;
  type: optionObjectOptionT;
  optionsGroup: IAvailableOption | IAvailableGeometryOption;
}
export const ObjectOptions: React.FC<PropsI> = props => {
  const { productId, type, optionsGroup } = props;
  const { id: proxyId, options, proxyName } = optionsGroup;

  if (options.length > 1) {
    return (
      <ObjectOptionGroup
        productId={productId}
        type={type}
        proxyId={proxyId}
        options={options}
        title={proxyName}
      />
    );
  }

  return (
    <>
      {options.map((option, idx) => (
        <ObjectOption
          key={idx}
          productId={productId}
          type={type}
          proxyId={proxyId}
          option={option}
          title={proxyName}
        />
      ))}
    </>
  );
};
